<template>
  <div>
    <el-dialog :visible.sync="addDialogVisible" :title="params.id ? '编辑策略' : '新增策略'" width="50%"
      :modal-append-to-body="false" @closed="handleClose">
      <div>
        <!-- 表单 -->
        <el-form :model="params" :rules="rules" label-width="120px" ref="params" size="mini">
          <el-form-item label="入口选择：" prop="code">
            <!-- 入口选择  下拉选择-->
            <el-select v-model="params.code" placeholder="请选择">
              <el-option v-for="item in entryScene" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="描述：" prop="description">
            <el-input type="textarea" show-word-limit :autosize="{ minRows: 2, maxRows: 99 }" maxlength="999"
              v-model="params.description" placeholder="请输入描述"></el-input>
          </el-form-item>
          <!-- 渠道选择 单选radio -->
          <el-form-item label="渠道选择：" prop="channel">
            <el-radio-group v-model="params.channel">
              <el-radio label="0">全部渠道</el-radio>
              <el-radio label="1">指定渠道</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="params.channel === '1'" label="">
            <el-input type="textarea" @focus="handleClick()" v-model="params.appidFilterNames">
            </el-input>
          </el-form-item>
          <!-- 协议版本号 单选radio-->
          <el-form-item label="协议版本号：" prop="protocolVersionChoose">
            <el-radio-group v-model="params.protocolVersionChoose">
              <el-radio label="0">全部版本</el-radio>
              <el-radio label="1">指定版本</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="params.protocolVersionChoose === '1'" label="">
            <!-- 协议版本的下拉列表 (取业务字典配置) -->
            <el-select multiple v-model="params.protocolVersion" placeholder="请选择">
              <el-option v-for="item in protocolVersionList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 关联推荐策略  下拉选择-->
          <el-form-item label="关联推荐策略：" prop="tacticsId">
            <el-select v-model="params.tacticsId" placeholder="请选择关联推荐策略">
              <el-option v-for="item in strategyList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <!--  状态 radio -->
          <el-form-item label="状态：" prop="status">
            <el-radio-group v-model="params.status">
              <el-radio :label="1">上线</el-radio>
              <el-radio :label="0">下线</el-radio>
            </el-radio-group>
          </el-form-item>
          <!--- 备注    - 非必填、多行输入框、 999 字符限制-->
          <el-form-item label="备注：" prop="remark">
            <el-input type="textarea" show-word-limit :autosize="{ minRows: 2, maxRows: 99 }" maxlength="999"
              v-model="params.remark" placeholder="请输入备注"></el-input>
          </el-form-item>
        </el-form>
      </div>

      <!-- 关闭按钮 -->
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="handleSave">保存</el-button>
        <el-button size="small" @click="handleClose">关闭</el-button>
      </span>
    </el-dialog>
    <channel-popups :isAppendToBody="false" :modelIsAppendToBody="false" :app-id="params.appidFilterList"
      :visible.sync="showPopups" @comfirm="handleConfirm"></channel-popups>
  </div>
</template>

<script>
import Message from "@/components/Message";
import ElementPagination from "@/components/ElementPagination";
import {
  getEntryScene,
  getRecommendStrategyList,
  addEntryItem,
  updateEntryItem,
  getProtocolVersion,
} from "@/api/entryManage/index";
import ChannelPopups from "@/components/channel-popups";
export default {
  name: "WebSassMemberRightLog",
  components: {
    ElementPagination,
    ChannelPopups,
  },
  props: {
    addDialogVisible: {
      type: Boolean,
      default: false,
    },
    /** 记录的id */
    params: {
      type: Object,
      default: () => ({
        /** id */
        id: "",
        /** 入口场景 */
        code: "",
        /** 描述 */
        description: "",
        /** 渠道对象 */
        channels: [],
        /** 渠道选择 */
        channel: "1",
        /** 指定渠道  */
        appidFilterNames: "",
        /** 指定渠道id */
        appidFilterList: "",
        /** 推荐策略 */
        tacticsId: "",
        /** 协议版本号的选择 */
        protocolVersionChoose: "",
        /** 协议版本号 */
        protocolVersion: "",
        /** 状态 */
        status: "",
        /** 备注 */
        remark: "",
      }),
    },
  },
  watch: {
    addDialogVisible(newVal) {
      if (newVal) {
        console.log("拿到的数据", this.params);
        // 处理渠道数据的的回填
        if (this.params.id && this.params.channels[0].channelId === 0) {
          // 用$set赋值
          this.$set(this.params, "channel", "0");
          // this.params.channel = '0'
        } else {
          this.$set(this.params, "channel", "1");
          // this.params.channel = '1'
          try {
            this.params.appidFilterList = this.params.channels
              .map((item) => {
                return String(item.channelId);
              })
              .join(",");
            this.params.appidFilterNames = this.params.channels
              .map((item) => {
                return item.channelName;
              })
              .join(",");
          } catch (error) {
            this.params.appidFilterList = "";
            this.params.channelName = "";
          }
        }
        // 处理协议版本号的回填
        if (this.params.id && this.params.vers[0].ver === "0") {
          this.$set(this.params, "protocolVersionChoose", "0");
          // this.params.protocolVersionChoose = '0'
        } else {
          this.$set(this.params, "protocolVersionChoose", "1");
          // this.params.protocolVersionChoose = '1'
          // 遍历赋值
          const res = this.params.vers  ? this.params.vers.map((item) => {
            return item.ver;
          }) : [];
          console.log("res", res);
          this.$set(this.params, "protocolVersion", res);
          // this.params.protocolVersion = this.params.vers[0].ver
        }
        console.log("拿到的数据处理过后", this.params);
        /** 获取操作日志 */
        // this.getLogList();
      }
    },
  },
  data() {
    return {
      /** 业务字典的协议版本号 */
      protocolVersionList: [],
      /** 关联推荐策略里的列表 */
      strategyList: [],
      /** 渠道选择框的显隐 */
      showPopups: false,
      /** 业务字典中的入口场景 */
      entryScene: [],
      /** 表单的验证规则  */
      rules: {
        code: [
          { required: true, message: "请选择入口场景", trigger: "change" },
        ],
        channel: [
          { required: true, message: "请选择渠道选择", trigger: "change" },
        ],
        tacticsId: [
          { required: true, message: "请选择关联推荐策略", trigger: "change" },
        ],
        protocolVersionChoose: [
          {
            required: true,
            message: "请选择协议版本号",
            trigger: "change",
          },
        ],
        status: [{ required: true, message: "请选择状态", trigger: "change" }],
      },
    };
  },

  async created() {
    const { data } = await getEntryScene();
    console.log("获取业务字典中入口场景的响应", data);
    this.entryScene = data.data.map((item) => ({
      label: item.dictValue,
      value: Number(item.dictKey),
    }));
    const { data: strategyData } = await getRecommendStrategyList();
    this.strategyList = strategyData.data.map((item) => ({
      label: item.name,
      value: item.id,
    }));
    console.log("获取关联推荐策略的响应", strategyData);
    const { data: list } = await getProtocolVersion();
    this.protocolVersionList = list.data.map((item) => {
      return {
        label: item.dictValue,
        value: item.dictKey,
      };
    });
    console.log("获取业务字典中的协议版本号的响应", list);
  },

  methods: {
    //^ ^--------------新增/编辑对话框内 start-------------^ ^
    /** 处理数据 */
    handleData() {
      /** 处理渠道数据 */
      if (this.params.channel !== "0") {
        const channelIds = this.params.appidFilterList.split(",");
        const channelNames = this.params.appidFilterNames.split(",");
        const channels = [];
        for (let i = 0; i < channelIds.length; i++) {
          channels.push({
            channelId: Number(channelIds[i]),
            channelName: channelNames[i],
          });
        }
        this.params.channels = channels;
      } else {
        const channels = [
          {
            channelId: 0,
            channelName: "全部渠道",
          },
        ];
        this.params.channels = channels;
      }
      /** 处理协议版本号 */
      const vers = [];
      if (this.params.protocolVersionChoose === "0") {
        this.params.protocolVersion = "全部版本";
        vers.push({
          ver: "0",
        });
      } else {
        /** 遍历添加 */
        this.params.protocolVersion.forEach((item) => {
          vers.push({
            ver: item,
          });
        });
      }
      this.params.vers = vers;
    },
    /** 确认保存的事件 */
    handleSave() {
      this.$refs["params"].validate((valid) => {
        if (valid) {
          console.log("表单验证通过", this.params);
          /** 处理数据 */
          this.handleData();
          const params = { ...this.params };

          console.log("处理过后的数据", params);
          /** 调用接口 */
          if (params.id) {
            console.log("是编辑");
            this.update(params);
          } else {
            console.log("是新增");
            this.add(params);
          }
        } else {
          /** 提示用户 */
          Message.error("表单验证失败");
          console.log("表单验证失败");
          return false;
        }
      });
    },
    /** 新增入口场景接口 */
    async add(params) {
      const { data } = await addEntryItem(params);
      console.log("新增入口场景接口的响应", data);
      /** 提示用户 */
      if (data.code === 200) {
        Message.success("新增成功");
        /** 关闭对话框 */
        this.handleClose();
        /** 通知父组件更新列表数据 */
        this.$emit("loadList");
      }
    },
    /** 修改入口场景接口 */
    async update(params) {
      const { data } = await updateEntryItem(params);
      console.log("编辑入口场景接口的响应", data);
      /** 提示用户 */
      if (data.code === 200) {
        Message.success("修改成功");
        /** 关闭对话框 */
        this.handleClose();
        /** 通知父组件更新列表数据 */
        this.$emit("loadList");
      }
    },
    /** 确认渠道选择 */
    handleConfirm(data) {
      console.log("渠道选择的数据", data);
      const { appId, nameStr } = data;
      this.params.appidFilterList = appId;
      this.params.appidFilterNames = nameStr;
      // this.$nextTick(() => {
      //   this.$refs['form'] && this.$refs['form'].clearValidate()
      // })
    },
    /** 渠道选择框 */
    handleClick() {
      this.showPopups = true;
    },
    /** 对话框关闭 */
    handleClose() {
      this.$emit("update:addDialogVisible", false);
      this.$emit("update:params", {
        /** id */
        id: "",
        /** 入口场景 */
        code: "",
        /** 描述 */
        description: "",
        /** 渠道对象 */
        channels: [],
        /** 渠道选择 */
        channel: "1",
        /** 指定渠道  */
        appidFilterNames: "",
        /** 指定渠道id */
        appidFilterList: "",
        /** 推荐策略 */
        tacticsId: "",
        /** 状态 */
        status: "",
        /** 备注 */
        remark: "",
      });
      /** 关闭之后清空数据 */
      this.params = {
        /** 入口场景 */
        code: "",
        /** 描述 */
        description: "",
        /** 渠道选择 */
        channel: "2",
        /** 指定渠道  */
        appidFilterNames: "",
        /** 指定渠道id */
        appidFilterList: "",
        /** 推荐策略 */
        tacticsId: "",
        /** 协议版本号的选择 */
        protocolVersionChoose: "",
        /** 协议版本号 */
        protocolVersion: "",
        /** 状态 */
        status: "",
        /** 备注 */
        remark: "",
      };
      console.log("关闭对话框的事件", this.params);
      /** 清空表单验证规则 */
      this.$nextTick(() => {
        this.$refs["params"] && this.$refs["params"].clearValidate();
      });
    },
    //^ ^--------------新增/编辑对话框内 end-------------^ ^

    //^ ^--------------分页相关 start-------------^ ^
    /** 每页条数change */
    handleSizeChange(val) {
      this.searchParams.size = val;
      Message.success(`每页 ${val} 条`);
      this.getLogList();
    },
    /** 当前页change */
    handleCurrentChange(val) {
      this.searchParams.current = val;
      Message.success(`当前页 ${val}`);
      this.getLogList();
    },
    //^ ^--------------分页相关 end-------------^ ^
  },
};
</script>

<style lang="scss" scoped></style>
